export default __webpack_public_path__ + "static/media/profileImage.6e62f80f.jpg";